import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { CloseConfirmComponent } from '../../close-confirm/close-confirm.component';
import moment from 'moment';

@Component({
  selector: 'vex-addon-detail',
  templateUrl: './addon-detail.component.html',
  styleUrls: ['./addon-detail.component.scss']
})
export class AddonDetailComponent implements OnInit {
  iconFormFlag: any;
  flags = {
    en: 'flag:united-states',
    it: 'flag:italy'
  };
  currentLang: string;
  formLang: any;
  ngForm: any = {
    i18nName: {
      EN: "",
      IT: ""
    },
    i18nDescription: {
      EN: "",
      IT: ""
    },
    validationDate: {
      from: "",
      to: ""
    },
    price: "",
    itemPriceId: "",
    oldPrice: "",
    other: "",
    quantity: {
      min: 1,
      max: 10
    },
    currency: "$",
    promoCodeChargebee: [],
    planAllowed: [],
    category: "",
    orderIndex: 0,
    tags: [],
    imgUrl: ""
  };

  validationDate: any = {
    from: {
      day: "",
      month: "",
      year: "",
    },
    to: {
      day: "",
      month: "",
      year: "",
    }
  }
  subs: any = [];
  categories: any = [{key: 'digital_products', value: this.translate.instant('ADDONS_LIST.digital_products')}, {key: 'consultancy', value: this.translate.instant('ADDONS_LIST.consultancy')}, {key: 'physical_products', value: this.translate.instant('ADDONS_LIST.physical_products')}];

  constructor(@Inject(MAT_DIALOG_DATA) public item: any['item'], public translate: TranslateService, public guiService: GuiService, public restService: RestService, private dialogRef: MatDialogRef<any>, public dialog: MatDialog) {
    this.currentLang = translate.currentLang || translate.getDefaultLang();
  }

  ngOnInit(): void {
    this.changeFormLanguage(this.translate.currentLang);
    this.getSubs();
    if (this.item) {
      this.ngForm = this.item;
      const datePartFrom = this.item.validationDate.from.split('T')[0];
      const datePartTo = this.item.validationDate.to.split('T')[0];
      const [day_from, month_from, year_from] = datePartFrom.split('/');
      const [day_to, month_to, year_to] = datePartTo.split('/');
      console.debug(this.validationDate)
      this.validationDate.from.day = day_from;
      this.validationDate.from.month = month_from;
      this.validationDate.from.year = year_from;
      this.validationDate.to.day = day_to;
      this.validationDate.to.month = month_to;
      this.validationDate.to.year = year_to;
      console.debug(this.validationDate)
    }
  }

  changeFormLanguage(lang) {
    this.iconFormFlag = this.flags[lang];
    this.formLang = lang;
  }

  confirmClose() {
    this.dialog.open(CloseConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris) => {
      if (ris == 'true') {
        this.dialogRef.close()
      }
    })
  }


  submit() {
    console.debug(this.ngForm);
    if (this.item) {
      const obj = this.ngForm;
      obj.validationDate.from = this.formatDate(this.validationDate.from);
      obj.validationDate.to = this.formatDate(this.validationDate.to);

      this.restService.postServiceUserId('node', '/update-addon', obj, this.guiService.userLogged.user.id).subscribe((ris) => {
        this.dialogRef.close('done');
      })
    } else {
      const obj = this.ngForm;
      obj.validationDate.from = this.formatDate(this.validationDate.from);
      obj.validationDate.to = this.formatDate(this.validationDate.to);

      this.restService.postServiceUserId('node', '/create-addon', obj, this.guiService.userLogged.user.id).subscribe((ris) => {
        this.dialogRef.close('done');
      })
    }

  }

  formatDate(dateObj: { day: number; month: number; year: number }): string | null {
    const { day, month, year } = dateObj;

    if (day && month && year) {
      const date = moment({ year, month: month - 1, day });
      return date.format("DD/MM/YYYY");
    }

    return null;
  }

  getSubs() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.postService('subscriptions', '/search', { page: 0, size: 20 }).subscribe((ris) => {
      this.subs = ris["items"];
      this.guiService.showSpinner = false
    })
  }

  isFormInvalid() {
    console.debug(this.ngForm)
    const obj = this.ngForm;
    obj.validationDate.from = this.formatDate(this.validationDate.from);
    obj.validationDate.to = this.formatDate(this.validationDate.to);

    if (!this.ngForm.i18nName.IT || !this.ngForm.i18nName.EN) return true;
    if (!this.ngForm.i18nDescription.IT || !this.ngForm.i18nDescription.EN) return true;
    if (!obj.validationDate.from || !obj.validationDate.to) return true;

    if (!this.ngForm.price) return true;
    if (!this.ngForm.itemPriceId) return true;
    if (!this.ngForm.currency) return true;
    if (!this.ngForm.imgUrl) return true;

    if (!this.ngForm.planAllowed || this.ngForm.planAllowed.length === 0) return true;

    return false;
  }
}
